import clsx from 'clsx';
import NextLink from 'next/link';
import { ReactNode } from 'react';

import { ImageClient } from '../../Image/ImageClient';
import { Typography } from '../../Typography/Typography';

import styles from './RichTextComponents.module.scss';

export const Bold = children => <b className="bold">{children}</b>;
export const Italic = children => <i className={styles.italic}>{children}</i>;
const headings = ['h1', 'h2', 'h3', 'h4'];

export const Link = (
    children: ReactNode,
    { linktype, href, target }: { linktype?: string; href?: string; target?: string },
) => {
    if (linktype === 'email') {
        return <a href={`mailto:${href}`}>{children}</a>;
    }
    if (href) {
        return (
            <a
                href={href}
                target={target}
            >
                {children}
            </a>
        );
    }
    return <NextLink href={href || ''}>{children}</NextLink>;
};
export const Heading = (children, props) => (
    <Typography
        looksLike={props?.level}
        as={`h${(props?.level as '1') || '2' || '3' || '4' || '5' || '6'}`}
        className={clsx(styles.heading)}
    >
        {children}
    </Typography>
);
export const Paragraph = (children, pStyle) => (
    <Typography
        as={headings.includes(pStyle) ? pStyle : 'p'}
        looksLike={pStyle}
        className={clsx(styles.pararaph)}
    >
        {children}
    </Typography>
);
export const Ol = children => (
    <Typography
        as="ol"
        className={styles.olRte}
    >
        {children}
    </Typography>
);
export const Ul = children => (
    <Typography
        as="ul"
        className={styles.ulRte}
    >
        {children}
    </Typography>
);
export const Br = () => <br className={styles.BrRte} />;
export const ImageRte = (children, props) => {
    const { src, alt, copyright, focus } = props;

    return (
        <span className={styles.imageWrapper}>
            <ImageClient
                src={src}
                overrideSrc={src}
                alt={alt}
                height={500}
                width={500}
                className={styles.image}
                focalPoints={focus}
                jsonData={{
                    images: [
                        {
                            contentUrl: src,
                            copyrightNotice: copyright,
                        },
                    ],
                }}
            />
        </span>
    );
};
